'use client';

import { useEffect, useState } from 'react';

import type { SearchBreed } from '@/features/breeds/breeds.api';
import { logError } from '@/lib/logger';

let cachedBreeds: SearchBreed[] | null = null;
let inFlight: Promise<SearchBreed[]> | null = null;

const loadOnce = (): Promise<SearchBreed[]> => {
  if (cachedBreeds) return Promise.resolve(cachedBreeds);
  inFlight ??= fetch('/api/search-breeds')
    .then((res) => {
      if (!res.ok) throw new Error(`search-breeds ${res.status}`);
      return res.json() as Promise<SearchBreed[]>;
    })
    .then((breeds) => {
      cachedBreeds = Array.isArray(breeds) ? breeds : [];
      return cachedBreeds;
    })
    .catch((error) => {
      logError('[useSearchBreedOptions] Failed to load breeds', error);
      inFlight = null;
      return [];
    });
  return inFlight;
};

export const useSearchBreedOptions = (): SearchBreed[] => {
  const [breeds, setBreeds] = useState<SearchBreed[]>(cachedBreeds ?? []);

  useEffect(() => {
    if (cachedBreeds) return;
    let active = true;
    void loadOnce().then((loaded) => {
      if (active) setBreeds(loaded);
    });
    return () => {
      active = false;
    };
  }, []);

  return breeds;
};
